module.exports = __webpack_public_path__ + "media/flags/pw-c0deb8bf.svg";